import React from "react";

// Top-level error boundary. Catches render-time exceptions inside its subtree
// so a single null-read in one route doesn't take the whole site to a white
// screen. Each <Routes> child is wrapped individually in Main.js, and the
// whole app is wrapped again in App.js as a last-resort safety net.
class ErrorBoundary extends React.Component {
  state = {error: null};

  static getDerivedStateFromError(error) {
    return {error};
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info?.componentStack);
    // Feed the same diagnostics channel the boot guard uses, so every crash
    // is inspectable from the console via window.__rdErrors.
    if (window.__rdErrors) {
      window.__rdErrors.push("[render] " + (error && error.message));
    }
  }

  handleReset = () => {
    this.setState({error: null});
  };

  render() {
    if (!this.state.error) return this.props.children;

    if (typeof this.props.fallback === "function") {
      return this.props.fallback(this.state.error, this.handleReset);
    }

    return (
      <div className="rd-fatal" role="alert" style={{
        padding: "64px 24px",
        display: "flex",
        justifyContent: "center",
      }}>
        <div style={{
          maxWidth: 560,
          width: "100%",
          textAlign: "center",
          padding: "40px 32px",
          borderRadius: 18,
          border: "1px solid rgba(140, 67, 206, 0.25)",
          boxShadow: "0 16px 48px rgba(0, 0, 0, 0.12)",
        }}>
          <div style={{
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: "0.14em",
            textTransform: "uppercase",
            color: "#8c43ce",
            marginBottom: 12,
          }}>
            Temporary glitch
          </div>
          <h2 style={{marginBottom: 8}}>This section hit a snag.</h2>
          <p style={{opacity: 0.75, marginBottom: 20, lineHeight: 1.6}}>
            The rest of the site is unaffected. The error has been logged to the
            browser console — you can retry this section or head back home.
          </p>
          <div style={{display: "flex", gap: 10, justifyContent: "center", flexWrap: "wrap"}}>
            <button type="button" onClick={this.handleReset} className="rdf-button">
              Try again
            </button>
            <a href="/" className="rdf-button" style={{textDecoration: "none"}}>
              Go home
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
